import React from "react";
import { Text, Loading } from "@nextui-org/react";
import { motion } from "framer-motion";
import AltEntryCard from "../ui/AltEntryCard";
import AltDeductionCard from "../ui/AltDeductionCard";

const AltEntriesCardList = ({
  loading,
  error,
  filteredItems,
  viewBy,
  checkedIds = new Set(),
  onToggle,
}) => {
  return (
    <motion.div
      className="ordersDiv alignDivCenter"
      style={{ marginTop: "5px" }}
    >
      {loading && <Loading type="spinner" size="lg" />}

      {!loading && error && (
        <Text
          color="error"
          css={{
            br: "12px",
            bgColor: "$red50",
            py: "5px",
            px: "10px",
            my: "10px",
          }}
        >
          An error occurred while trying to retrieve alt entries!
        </Text>
      )}

      {!loading && !error && filteredItems.length === 0 && (
        <Text css={{ my: "20px" }} color="gray">
          No{" "}
          {viewBy === "entries"
            ? "entry"
            : viewBy === "deductions"
              ? "deduction"
              : ""}{" "}
          records found.
        </Text>
      )}

      {!loading &&
        !error &&
        filteredItems.length > 0 &&
        filteredItems.map((doc) =>
          doc.recordType === "deduction" ? (
            <AltDeductionCard
              key={doc._id}
              doc={doc}
              checked={checkedIds.has(doc._id)}
              onToggle={onToggle}
            />
          ) : (
            <AltEntryCard
              key={doc._id}
              doc={doc}
              checked={checkedIds.has(doc._id)}
              onToggle={onToggle}
              isCleared={!!doc.isCleared}
            />
          ),
        )}
    </motion.div>
  );
};

export default AltEntriesCardList;
